// facts.ts
import { PendingType } from "../types";
import { isApproved, isInitialAI } from "./history";

type EventType = TranslationHistoryItem["eventType"];

// Determines the type of pending translation based on history.
export const getPendingType = (
  history: Array<{ eventType: EventType; title?: string }>,
  translationReview?: TranslationReview | null
): PendingType => {
  if (isApproved(history)) return "none";
  if (isInitialAI(history)) return "ai";
  const submittedBy = translationReview?.author;
  return submittedBy ? "manual" : "none";
};
